import React, { useState, useEffect } from 'react';
import {
    Container,
    Card,
    Button,
    Collapse,
    Modal,
    Form,
    Badge,
    Col
} from 'react-bootstrap';
import { FaEye, FaCheckCircle, FaEdit, FaTimes,FaDownload, FaFilePdf, FaFileExcel, FaFileImage, FaPrint } from 'react-icons/fa';
import HomeService from '../services/HomeService';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ExcelPreviewModal from '../Utils/PreviewModal';
import ActionExcelPreviewModal from '../Utils/PreviewModal';
import logo from '../assets/logo.png';
import ApprovalProcessService from '../services/ApprovalProcessService';

const DashboardReport = () => {
    const companyName = localStorage.getItem('compantName') || "Company";
    const departmentName = localStorage.getItem('departmentName') || "Department";
    const navigate = useNavigate();
    const reportTitle = sessionStorage.getItem('reportTitle');

    const actionType = sessionStorage.getItem('actionType');

    const [reportData, setReportData] = useState([]);
    const [openRowIndex, setOpenRowIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [remark, setRemark] = useState('');
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const [historyItem, setHistoryItem] = useState(null);

    const { setLoading } = useLoading();
    const [remarkError, setRemarkError] = useState('');
    const [historyData, setHistoryData] = useState([]);
    const [excelshowModal, setexcelShowModal] = useState(false);
    const [actionexcelshowModal, setactionexcelShowModal] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [actionexcelData, setactionExcelData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [actionfileName, setactionFileName] = useState("");
    const [fileURL, setFileURL] = useState("");
    const [actionfileURL, setactionFileURL] = useState("");
    const [showDescription, setShowDescription] = useState(true);
    const [showApproverAction, setShowApproverAction] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState(null);
    const [attachmentError, setAttachmentError] = useState('');
    const [attachments, setAttachments] = useState([]);

    const handlePreviewExcel = (data, name, url) => {
        const nameParts = name.split("_");
        const displayName = nameParts.length > 1 ? nameParts.slice(1).join("_") : name;
        setExcelData(data || []);
        setFileName(displayName);
        setFileURL(url || "");
        setexcelShowModal(true);
    };
    const handleActionPreviewExcel = (data, name, url) => {

        const nameParts = name.split("_");
        const displayName = nameParts.length > 1 ? nameParts.slice(1).join("_") : name;
        setactionExcelData(data || []);
        setactionFileName(displayName);
        setactionFileURL(url || "");
        setactionexcelShowModal(true);
    };
    const openDetailsModal = async (lcnumber) => {

        setLoading(true);
        const response = await HomeService.getPrintPreview(lcnumber);
        if (response?.success) {

            const mappedData = response.data.result.map((item) => ({
                id: item.id,
                lcNumber: item.lcNumber,
                title: item.title,
                departmentName: item.departmentName,
                companyName: item.companyName,
                lcType: item.lcType,
                description: item.description,
                assignedBy: item.assignedBy,
                approverName: item.approverName,
                approvalCommentsList: item.approvalCommentsList,
                approverNameList: item.approverNameList,
                statusText: item.statusText,
                actionOn: item.actionOn,
                requestedOn: item.requestedOn

            }));
            setSelectedDetails(mappedData[0]);
            setShowDetailsModal(true);
            setLoading(false);
        } else {
            console.warn('No data found.');
            setShowDetailsModal(false);
            setLoading(false);
        }
    };
    const handlePrint = () => {

        // if (!selectedDetails) return;

        const contentToPrint = document.getElementById("printable-details").cloneNode(true);

        // Optional: hide print/close buttons if present
        const printButton = contentToPrint.querySelector("#btnPrint");
        if (printButton) {
            printButton.style.display = "none";
        }
        const closeButton = contentToPrint.querySelector("#btnClose");
        if (closeButton) {
            closeButton.style.display = "none";
        }

        const printWindow = window.open('', '', 'height=600,width=800');

        printWindow.document.write('<html><head><title>Print</title>');

        // Dynamically include all styles (Bootstrap + local)
        const styles = document.querySelectorAll("link[rel='stylesheet'], style");
        styles.forEach(style => {
            printWindow.document.write(style.outerHTML);
        });

        printWindow.document.write('</head><body>');
        printWindow.document.write(contentToPrint.innerHTML);
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.focus();
        printWindow.print(); // No delay
        printWindow.close();
    };

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        const validExtensions = ["png", "jpg", "jpeg", "pdf", "xls", "xlsx"];
        const validFiles = [];
        const invalidFiles = [];

        // Validate file extensions
        newFiles.forEach((file) => {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (validExtensions.includes(fileExtension)) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file.name);
            }
        });

        if (invalidFiles.length > 0) {
            const errorMessage = `Only PNG, JPG, JPEG, PDF, XLS, XLSX files are allowed. Invalid: ${invalidFiles.join(', ')}`;

            setAttachmentError(errorMessage);
            e.target.value = null;
            return;
        } else {
            setAttachmentError('');
        }

        // Check for duplicate file names
        const existingFileNames = attachments.map(file => file.name);
        const duplicateFiles = validFiles.filter(file => existingFileNames.includes(file.name));

        if (duplicateFiles.length > 0) {
            const errorMessage = `Duplicate file(s) not allowed: ${duplicateFiles.map(f => f.name).join(', ')}`;
            setAttachmentError(errorMessage);
            e.target.value = null;
            return;
        } else {
            setAttachmentError('');
        }

        // Check for total file count > 2
        const totalFiles = attachments.length + validFiles.length;
        if (totalFiles > 2) {
            const errorMessage = 'You can only upload up to 2 files.';
            setAttachmentError(errorMessage);
            e.target.value = null;
            return;
        } else {
            setAttachmentError('');
        }

        // Append new valid files to existing attachments
        setAttachments((prevFiles) => [...prevFiles, ...validFiles]);

        // Reset the file input
        e.target.value = null;
    };

    const handleEditClick = (id) => {
        navigate("/editDetails", { state: { id } });
    };

    const handleRejectStatus = async (id) => {
        const confirmed = window.confirm("Are you sure you want to reject this request? Once rejected, you will not be able to take any further action on it.");
        if (confirmed) {
            try {

                const response = await ApprovalProcessService.InsertRejectStatus(id);

                if (response.data.statusCode === 200) {
                showToast("Status updated successfully.", 'success', { autoClose: 700 });
                navigate("/home");
                }
                // You may want to refresh the list or update state here
            } catch (error) {
                console.error("Error updating status:", error);
                alert("Failed to update status");
            }
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const response = await HomeService.getDashboardDetailsData(actionType);
            if (response?.success) {

                const mappedData = response.data.result.map((item) => ({
                    id: item.id,
                    companyName: item.companyName,
                    departmentName: item.departmentName,
                    approvalTypeName: item.lcType,
                    description: item.description,
                    lcNumber: item.lcNumber,
                    assignedBy: item.assignedBy,
                    attachmentFiles: item.attachmentFiles,
                    approverName: item.approverName,
                    title: item.title, // Contains the filenames
                    isRevert: item.isRevert,
                    currentApproverId: item.currentApproverId,
                    requestedBy: item.requestedBy
                }));
                setReportData(mappedData);
            } else {
                console.warn('No data found.');
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    const toggleRow = (index, item) => {
        setOpenRowIndex(openRowIndex === index ? null : index);
        handleShowHistory(item);
    };

    const handleOpenModal = (item) => {
        setSelectedItem(item);
        setRemark('');
        setRemarkError('');
        setShowModal(true);
        setAttachmentError('');
        setAttachments([]);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleAction = async (actionType, actionStatus) => {
        if (!remark.trim()) {
            setRemarkError('Remark is required.');
            return;
        }
        setRemarkError('');
        setLoading(true);
        let response;
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('id', Number(selectedItem?.id));
            formDataToSend.append('statusId', Number(actionStatus));
            formDataToSend.append('remark', remark);
            formDataToSend.append('actionType', actionType);
            formDataToSend.append('lcNumber', selectedItem.lcNumber);
            attachments.forEach((file, index) => {
                formDataToSend.append(`actionAttachments`, file);
            });


            response = await HomeService.CreateApprovalAction(formDataToSend);

            if (response.data.statusCode === 200) {
                setShowModal(false);
                setLoading(false);
                showToast("Data inserted successfully.", 'success', { autoClose: 700 });
                navigate("/home");
            } else {
                toast.error('Failed to approve. Please try again.');
                setLoading(false);
            }
        } catch (error) {
            toast.error(response.errorMessage || 'An error occurred while submitting the form.');
            console.error('Submission Error:', error);
            setLoading(false);
        }
    };

    const handleShowHistory = async (item) => {
        try {
            setLoading(true);
            const response = await HomeService.getApproverHistory(item.id);
            if (response?.success) {
                setHistoryData(response.data.result);
            } else {
                setHistoryData([]);
            }
            setHistoryItem(item);
            setShowHistoryModal(true);
        } catch (error) {
            console.error("Error fetching history:", error);
            toast.error("Failed to load history.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <Container className="mt-4 small">
            <h6 className="text-left fw-bold mb-4 text-primary">{reportTitle}</h6>

            {reportData.map((item, index) => (
                <Card key={item.id} className="mb-3 shadow-sm border-0 rounded-4">
                    <Card.Body>
                        <div className="d-flex justify-content-between flex-wrap">
                            <div className="mb-2">
                                <Badge bg="secondary" className="me-2">#{item.lcNumber}</Badge>
                                <strong>{item.approvalTypeName} </strong>
                            </div>
                            <div className="d-flex gap-2">
                                {actionType === "Pending" && item.isRevert && (
                                    <Button
                                        variant="outline-warning"
                                        size="sm"
                                        title="Edit Request"
                                        onClick={() => handleEditClick(item.id)}
                                    >
                                        <FaEdit className="me-1" />
                                        Edit
                                    </Button>
                                )}
                                {actionType === "Pending" && item.isRevert && (
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        title="Reject Request"
                                        onClick={() => handleRejectStatus(item.id)}
                                        
                                    >
                                        <FaTimes className="me-1" />
                                        Reject
                                    </Button>
                                )}
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => toggleRow(index, item)}
                                >
                                    <FaEye className="me-1" />
                                    {openRowIndex === index ? 'Hide Description' : 'View Description'}
                                </Button>
                                {(actionType === "Pending" || actionType === "Hold")
                                    && item.currentApproverId != item.requestedBy && (
                                        <Button
                                            variant="outline-success"
                                            size="sm"
                                            onClick={() => handleOpenModal(item)}
                                        >
                                            <FaCheckCircle className="me-1" />
                                            Action
                                        </Button>
                                    )}

                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    title="Print"
                                    onClick={() => openDetailsModal(item.lcNumber)}
                                >

                                    <FaPrint />
                                </Button>


                            </div>
                        </div>

                        <div className="mt-2">
                            <div><strong>Subject Line:</strong> {item.title}</div>
                            <div><strong>Company:</strong> {companyName}</div>
                            <div><strong>Department:</strong> {departmentName}</div>
                            <div><strong>Requested By:</strong> {item.assignedBy}</div>
                            <strong>Approved By:</strong> {item.approverName}
                        </div>



                        {/* Attachments Section */}
                        <div className="d-flex gap-3 mt-2 flex-wrap">
                            {item.attachmentFiles !== "No Attachments" && item.attachmentFiles.split(",").map((fileName, idx) => {
                                const trimmedFileName = fileName.trim();
                                const nameParts = trimmedFileName.split("_");
                                const displayName =
                                    nameParts.length > 1
                                        ? nameParts[nameParts.length - 1]
                                        : trimmedFileName;

                                const fileExtension = trimmedFileName.split(".").pop().toLowerCase();
                                const isPdf = fileExtension === "pdf";
                                const isExcel = ["xls", "xlsx"].includes(fileExtension);
                                const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileExtension);
                                const shortName =
                                    displayName.length > 20
                                        ? displayName.slice(0, 17) + "..."
                                        : displayName;

                                return (
                                    <Button
                                        key={idx}
                                        variant="link"
                                        className="d-flex align-items-center gap-2 p-0"
                                        title={displayName}
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setLoading(true);
                                            try {
                                                await HomeService.actionpreviewAttachment(trimmedFileName, handlePreviewExcel, "ActionAttachment");
                                            } catch (err) {
                                                console.error("Error previewing file:", err);
                                                toast.error("Failed to preview file.");
                                            } finally {
                                                setLoading(false);
                                            }
                                        }}
                                    >
                                        {isPdf && <FaFilePdf color="red" />}
                                        {isExcel && <FaFileExcel color="green" />}
                                        {isImage && <FaFileImage color="orange" />}
                                        {!isPdf && !isExcel && !isImage && <FaDownload />}
                                        <span>{shortName}</span>
                                    </Button>
                                );
                            })}
                        </div>

                        {/* Excel Preview Modal */}
                        {item.attachmentFiles !== "No Attachments" && (
                            <ExcelPreviewModal
                                show={excelshowModal}
                                onHide={() => {
                                    setexcelShowModal(false);
                                    setExcelData([]);
                                    setFileName("");
                                    setFileURL("");
                                }}
                                excelData={excelData}
                                fileName={fileName}
                                fileURL={fileURL}
                            />
                        )}


                        <Collapse in={openRowIndex === index}>
                            <div className="mt-4">
                                {/* Description Toggle Header */}
                                <div className="d-flex align-items-center justify-content-between bg-light p-2 rounded">
                                    <strong className='text-primary'>Description</strong>
                                    <i
                                        className={`fas fa-chevron-${showDescription ? 'up' : 'down'} cursor-pointer`}
                                        onClick={() => setShowDescription(!showDescription)}
                                    />
                                </div>

                                {/* Description Collapse */}
                                <Collapse in={showDescription}>
                                    <div className="mt-2">
                                        <Card className="bg-white shadow-sm border-0">
                                            <Card.Body className="p-4">
                                                <div className="ck-content" dangerouslySetInnerHTML={{ __html: item.description }} />
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </Collapse>

                                {/* Approver Action Toggle Header */}
                                {historyData && historyData.length > 0 && (
                                    <>
                                        {/* Approver Action Toggle Header */}
                                        <div className="d-flex align-items-center justify-content-between bg-light p-2 mt-4 rounded">
                                            <strong className="text-primary">Approvers Action</strong>
                                            <i
                                                className={`fas fa-chevron-${showApproverAction ? 'up' : 'down'} cursor-pointer`}
                                                onClick={() => setShowApproverAction(!showApproverAction)}
                                            />
                                        </div>

                                        {/* Approver Action Collapse */}
                                        <Collapse in={showApproverAction}>
                                            <div className="mt-2 small">
                                                <div className="table-responsive">
                                                    <table className="table table-hover table-bordered align-middle">
                                                        <thead className="table-primary">
                                                            <tr>
                                                                <th scope="col">Sr No</th>
                                                                <th scope="col">Date</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Remark</th>
                                                                <th scope="col">Action By</th>
                                                                <th scope="col">Attachment</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historyData.map((entry, idx) => {
                                                                let badgeClass = "bg-secondary";
                                                                switch (entry.status.toLowerCase()) {
                                                                    case "approved":
                                                                        badgeClass = "bg-success";
                                                                        break;
                                                                    case "reject":
                                                                        badgeClass = "bg-danger";
                                                                        break;
                                                                    case "pending":
                                                                        badgeClass = "bg-warning text-dark";
                                                                        break;
                                                                    default:
                                                                        badgeClass = "bg-secondary";
                                                                }

                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>{idx + 1}</td>
                                                                        <td>{entry.actionOn}</td>
                                                                        <td>
                                                                            <span className={`badge ${badgeClass}`}>{entry.status}</span>
                                                                        </td>
                                                                        <td>{entry.remark}</td>
                                                                        <td>{entry.actionBy}</td>
                                                                        <td>
                                                                            {entry.actionAttachments !== "No Attachments" && entry.actionAttachments.split(",").map((fileName, idx) => {
                                                                                const trimmedFileName = fileName.trim();
                                                                                const nameParts = trimmedFileName.split("_");
                                                                                const displayName =
                                                                                    nameParts.length > 1
                                                                                        ? nameParts[nameParts.length - 1]
                                                                                        : trimmedFileName;

                                                                                const fileExtension = trimmedFileName.split(".").pop().toLowerCase();
                                                                                const isPdf = fileExtension === "pdf";
                                                                                const isExcel = ["xls", "xlsx"].includes(fileExtension);
                                                                                const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileExtension);
                                                                                const shortName =
                                                                                    displayName.length > 20
                                                                                        ? displayName.slice(0, 17) + "..."
                                                                                        : displayName;

                                                                                return (
                                                                                    <Button
                                                                                        key={idx}
                                                                                        variant="link"
                                                                                        className="d-flex align-items-center gap-2 p-0"
                                                                                        title={displayName}
                                                                                        onClick={async (e) => {
                                                                                            e.preventDefault();
                                                                                            e.stopPropagation();
                                                                                            setLoading(true);
                                                                                            try {
                                                                                                await HomeService.actionpreviewAttachment(trimmedFileName, handleActionPreviewExcel, "TicketActionAttachment");
                                                                                            } catch (err) {
                                                                                                console.error("Error previewing file:", err);
                                                                                                toast.error("Failed to preview file.");
                                                                                            } finally {
                                                                                                setLoading(false);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {isPdf && <FaFilePdf color="red" />}
                                                                                        {isExcel && <FaFileExcel color="green" />}
                                                                                        {isImage && <FaFileImage color="orange" />}
                                                                                        {!isPdf && !isExcel && !isImage && <FaDownload />}
                                                                                        <span>{shortName}</span>
                                                                                    </Button>
                                                                                );
                                                                            })}
                                                                        </td>
                                                                    </tr>
                                                                );

                                                            })}


                                                        </tbody>
                                                        {/* Excel ActionPreview Modal */}

                                                        <ActionExcelPreviewModal
                                                            show={actionexcelshowModal}
                                                            onHide={() => {
                                                                setactionexcelShowModal(false);
                                                                setactionExcelData([]);
                                                                setactionFileName("");
                                                                setactionFileURL("");
                                                            }}
                                                            excelData={actionexcelData}
                                                            fileName={actionfileName}
                                                            fileURL={actionfileURL}
                                                        />


                                                    </table>
                                                </div>
                                            </div>
                                        </Collapse>
                                    </>
                                )}

                            </div>
                        </Collapse>



                    </Card.Body>
                </Card>
            ))}

            {/* Action Modal */}
            <Modal show={showModal} onHide={handleCloseModal} centered fullscreen="sm-down">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedItem?.approvalTypeName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col>
                        <Form.Group controlId="remark">
                            <Form.Label>Remark</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={remark}
                                onChange={(e) => {
                                    setRemark(e.target.value);
                                    if (remarkError) setRemarkError('');
                                }}
                                isInvalid={!!remarkError}
                                placeholder="Enter your remarks here"
                            />
                            <Form.Control.Feedback type="invalid">
                                {remarkError}
                            </Form.Control.Feedback>
                        </Form.Group></Col>

                    <Col>
                        <Form.Group controlId="attachments">
                            <Form.Label>Attachments (Optional)</Form.Label>
                            <Form.Control
                                type="file"
                                multiple
                                onChange={handleFileChange}
                                isInvalid={!!attachmentError}
                            />
                            {attachmentError && (
                                <Form.Text className="text-danger">{attachmentError}</Form.Text>
                            )}
                        </Form.Group>

                        <div className="mt-2">
                            {attachments.map((file, index) => (
                                <div key={index} className="d-flex align-items-center gap-2 mb-1">
                                    <i className="bi bi-paperclip text-secondary"></i>
                                    <span>{file.name}</span>
                                </div>
                            ))}
                        </div>
                    </Col>

                </Modal.Body>
                <Modal.Footer className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                    <div className="w-100 d-flex justify-content-between gap-2">
                        <Button variant="success" onClick={() => handleAction('Approved', 1)} className="flex-fill">
                            Approve
                        </Button>
                        {actionType !== "Hold" && (
                            <Button variant="warning" onClick={() => handleAction('Hold', 3)} className="flex-fill">
                                Hold
                            </Button>
                        )}

                        <Button variant="danger" onClick={() => handleAction('Rejected', 2)} className="flex-fill">
                            Revert/Reject
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showDetailsModal}
                onHide={() => setShowDetailsModal(false)}
                centered
                dialogClassName="rounded-4 custom-preview-modal"
            >
                {/* Modal Header */}
                <Modal.Header
                    closeButton
                    className="border-bottom-0"
                    style={{
                        paddingTop: '1rem',
                        paddingBottom: '0.5rem',
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                    }}
                />

                {/* Modal Body */}
                <Modal.Body style={{ backgroundColor: '#f8f9fa', maxHeight: '70vh', overflowY: 'auto' }}>
                    <div id="printable-details">
                        {selectedDetails ? (
                            <div className="shadow-sm rounded-3 p-3 bg-white" style={{ border: '1px solid #dee2e6' }}>
                                {/* Title and Logo Row */}
                                <div
                                    className="position-relative mb-3"
                                    style={{
                                        borderBottom: '2px solid #0d6efd',
                                        paddingBottom: '0.4rem',
                                        height: '50px',
                                    }}
                                >
                                    <h2
                                        className="fw-bold text-primary mb-0 position-absolute top-50 start-50 translate-middle"
                                        style={{
                                            fontSize: '1.2rem',
                                            letterSpacing: '0.5px',
                                            textTransform: 'uppercase',
                                            margin: 0,
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {selectedDetails.lcType}
                                    </h2>
                                    <div className="position-absolute top-50 end-0 translate-middle-y pe-2">
                                        <img
                                            src={logo}
                                            alt="Logo"
                                            style={{
                                                maxWidth: '100px',
                                                height: 'auto',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Info Grid */}
                                <div className="mb-3" style={{ margin: 'auto' }}>
                                    {[
                                        [
                                            { label: 'Request Number', value: selectedDetails.lcNumber },
                                            { label: 'Company Name', value: selectedDetails.companyName },
                                            { label: 'Department', value: selectedDetails.departmentName },
                                        ],
                                        [
                                            { label: 'Current Status', value: selectedDetails.statusText },
                                            { label: 'Assigned By', value: selectedDetails.assignedBy },
                                            { label: 'Requested Date', value: selectedDetails.requestedOn },
                                        ],
                                    ].map((row, idx) => (
                                        <div
                                            key={idx}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                marginBottom: '0.5rem',
                                                borderBottom: '1px solid #e0e0e0',
                                                paddingBottom: '6px',
                                            }}
                                        >
                                            {row.map((item, i) => (
                                                <div
                                                    key={i}
                                                    style={{
                                                        flex: '1 1 30%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        textAlign: i === 0 ? 'left' : i === 1 ? 'center' : 'right',
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontWeight: '600',
                                                            color: '#495057',
                                                            fontSize: '0.75rem',
                                                            marginBottom: '2px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.05em',
                                                        }}
                                                    >
                                                        {item.label}
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontWeight: '700',
                                                            fontSize: '0.75rem',
                                                            color: '#212529',
                                                            wordBreak: 'break-word',
                                                        }}
                                                    >
                                                        {item.value || '-'}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>

                                {/* Description */}
                                <div className="mb-3">
                                    <h6 className="fw-semibold mb-2 text-secondary">
                                        Description: {selectedDetails.title}
                                    </h6>
                                    <div
                                        className="ck-content border rounded p-2"
                                        style={{
                                            backgroundColor: '#fff',
                                            fontSize: '0.75rem',
                                            lineHeight: '1.5',
                                            wordBreak: 'break-word',
                                        }}
                                        dangerouslySetInnerHTML={{ __html: selectedDetails.description }}
                                    />
                                </div>

                                {/* History Comments */}
                                <div className="mb-3">
                                    <h6 className="fw-semibold mb-2 text-secondary">History:</h6>
                                    <div className="border rounded p-2 bg-white">
                                        {(selectedDetails?.approvalCommentsList || []).map((approvercommentStr, idx) => {
                                            const match = approvercommentStr.match(/^(.*?)\s*\((.*?)\)$/);
                                            const name = match?.[1] || approvercommentStr;
                                            const comment = match?.[2] || '';
                                            return (
                                                <div
                                                    key={idx}
                                                    style={{
                                                        borderBottom: '1px solid #e0e0e0',
                                                        paddingBottom: '0.5rem',
                                                        marginBottom: '0.5rem',
                                                    }}
                                                >
                                                    <div style={{ fontWeight: '700', color: '#212529', fontSize: '0.75rem' }}>
                                                        {name}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontWeight: '500',
                                                            color: '#495057',
                                                            fontSize: '0.75rem',
                                                            marginTop: '0.25rem',
                                                        }}
                                                    >
                                                        {comment}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Approvers */}
                                <div className="mb-3">
                                    <h6 className="fw-semibold mb-2 text-secondary">Approvers:</h6>
                                    <div className="border rounded p-2 bg-white">
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                                            {(selectedDetails?.approverNameList || []).map((approverStr, idx) => {
                                                const match = approverStr.match(/^(.*?)\s*\((.*?)\)$/);
                                                const name = match?.[1] || approverStr;
                                                const approveDate = match?.[2] || '';
                                                return (
                                                    <div
                                                        key={idx}
                                                        style={{
                                                            flex: '1 0 45%',
                                                            minWidth: '120px',
                                                            borderBottom: '1px solid #e0e0e0',
                                                            paddingBottom: '0.5rem',
                                                        }}
                                                    >
                                                        <div style={{ fontWeight: '700', color: '#212529', fontSize: '0.75rem' }}>
                                                            {name}
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontWeight: '500',
                                                                color: '#495057',
                                                                fontSize: '0.75rem',
                                                                marginTop: '0.25rem',
                                                            }}
                                                        >
                                                            {approveDate}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>

                                <span style={{ fontSize: '0.7rem' }}>
                                    This document is digitally signed and does not require a physical signature.
                                </span>
                            </div>
                        ) : (
                            <p className="text-center text-muted">No details available.</p>
                        )}
                    </div>
                </Modal.Body>

                {/* Modal Footer */}
                <Modal.Footer
                    className="border-top-0"
                    style={{
                        paddingTop: '0.5rem',
                        paddingBottom: '0.5rem',
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                    }}
                >
                    <Button variant="outline-secondary" onClick={() => setShowDetailsModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handlePrint}>
                        Print
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    );
};

export default DashboardReport;
